import { Env } from "../../enums/env.enum";
import { APPS } from "../constants/constants";
import { EmptyRoutes } from "../../../components/routes/routers.comp";

const getSubdomain = (location: string) => {
    const locationParts = location.split(".");
    const sliceTill = locationParts.slice(-1)[0] === "localhost" ? -1 : -2;
    return locationParts.slice(0, sliceTill).join(".");
};

const getCurrentApp = () => {
    const main = APPS.find(app => app.main);
    if (!main) throw new Error("Must have main app");

    const currentSubdomain = getSubdomain(window.location.hostname);

    return (
        APPS.find(
            app => app.subdomains.find(subdomain => subdomain === currentSubdomain) != null
        ) ?? main
    );
};

export const getApp = (env: Env) => {
    const currentSubdomain = getSubdomain(window.location.hostname);
    const environment = currentSubdomain.includes("admin") ? `admin.${env}` : env;

    return APPS.find(app => app.subdomains.find(subdomain => subdomain === environment) != null);
};

export const getEmptyRoutes = () => {
    return EmptyRoutes;
};

export const getAppRoutes = () => {
    return getCurrentApp().routes;
};

export const getHeaderLogo = () => {
    return getCurrentApp().headerLogo;
};

export const getAppLogo = () => {
    return getCurrentApp().logo;
};

export const getAppColor = () => {
    return getCurrentApp().color;
};

export const lightTheme = getCurrentApp().lightTheme;
export const darkTheme = getCurrentApp().darkTheme;
export const isAdminPanel = getCurrentApp().adminPanel;
export const isTrialMode = getCurrentApp().trialMode;
export const isDevMode = getCurrentApp().devMode;
